export const START_APPLICATION_REQUEST = 'START_APPLICATION_REQUEST';
export const START_APPLICATION_COMPLETED = 'START_APPLICATION_COMPLETED';
export const SHOW_GLOBAL_TOAST_NOTIFICATION =
  'LAYOUT_SHOW_GLOBAL_TOAST_NOTIFICATION';
export const SET_SIDE_MENU_STATE = 'SET_SIDE_MENU_STATE';